import { render, staticRenderFns } from "./week.vue?vue&type=template&id=519ff0c9&scoped=true"
import script from "./week.vue?vue&type=script&lang=js"
export * from "./week.vue?vue&type=script&lang=js"
import style0 from "./week.vue?vue&type=style&index=0&id=519ff0c9&prod&scoped=true&lang=less"
import style1 from "./week.vue?vue&type=style&index=1&id=519ff0c9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519ff0c9",
  null
  
)

export default component.exports